import { combineReducers } from 'redux';
import { listTemplatesReducer } from './list-templates';
import { createTemplateReducer } from './create-template';

export default combineReducers({
  list: listTemplatesReducer,
  create: createTemplateReducer,
});
